import {isRejectedWithValue} from '@reduxjs/toolkit'

import {paymentSettingsApi} from '@vio/core/src/offer/services/paymentSettingsApi'

import {logEvent} from '../analytics/utils/logEvent'
import {MiddlewareType} from '../middlewareList'

const middleware: MiddlewareType = () => next => async action => {
  if (paymentSettingsApi.endpoints.getPaymentSettings.matchPending(action)) {
    const requestUrl = action?.meta?.arg?.originalArgs?.url
    logEvent('Services.PaymentSettingsAPI.Start', {url: requestUrl})
  }

  if (paymentSettingsApi.endpoints.getPaymentSettings.matchFulfilled(action)) {
    const paymentMethodsCount = action?.payload?.paymentMethods?.length ?? 0
    logEvent('Services.PaymentSettingsAPI.Done', {
      paymentMethodsCount
    })
  }

  if (
    paymentSettingsApi.endpoints.getPaymentSettings.matchRejected(action) &&
    isRejectedWithValue(action)
  ) {
    const errorPayload = action?.payload
    const errorCode = action?.error?.code
    logEvent('Services.PaymentSettingsAPI.Error', {
      error: errorPayload,
      errorCode
    })
  }

  return next(action)
}
export default middleware
